// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeFrontSide component
 */

import { toJS, expr } from 'mobx';
import connect from 'share/enhancers/Izenda.Connect';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import Chart from 'share/components/charting/Izenda.Chart';
import ChartToolbar from '../Izenda.ChartToolbar';
import { parser as chartDataParser } from 'share/utils/Izenda.ChartDataParser';
import ReportPartTitle from '../FieldContainers/Izenda.ReportPartTitle';
import { REPORT_PART_MODE } from 'logic/data/Izenda.ReportBodyConstants';
import PrintingUtils from 'share/utils/Izenda.PrintingUtils';
import ReportBodyConstants from 'logic/data/Izenda.ReportBodyConstants';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import VerticalLayout from 'share/components/controls/Izenda.VerticalLayout';
import { get, omit } from 'lodash/fp';
import actions from './Izenda.GaugeFrontSideActions';

@observer
class GaugePreview extends Component {
  static propTypes = {
    store: PropTypes.object,
    reportPart: PropTypes.object.isRequired
  };

  componentWillUnmount() {
    this.props.refreshData && this.props.refreshData(false);
  }

  componentDidMount() {
    this.props.updateDrillComponent.call(this);
  }

  componentDidUpdate() {
    this.props.updateDrillComponent.call(this);
  }

  render() {
    const {
      props,
      props: {
        viewMode,
        reportPart,
        printingMode,
        reportPart: { reportPartContent }
      }
    } = this;

    let chartProperties = toJS(reportPart.getReportPartProperties()) || {};
    let doesBreakPage = reportPartContent.checkBreakPage();
    const type = reportPartContent.type;

    let chartData = chartDataParser(
      reportPartContent.activeElmsByContainers,
      reportPartContent.expandedLevel,
      {
        fieldsMapping: reportPart.previewDataFieldsMapping,
        records: reportPart.previewDataRecords,
        rawData: reportPart.previewData
      },
      null
    );

    $izenda.extend(true, chartProperties, {
      colors: reportPart.getThemeColors(chartProperties),
      commonActions: {
        onDrilldown: props.onDrilldown,
        setPageSize: props.setPageSize,
        pointAction: props.pointAction
      }
    });

    // refresh data intervals
    props.refreshData && props.refreshData(true);

    if (ReportPartUtils.needToRenderLazyLoadingBar(reportPart, printingMode)) {
      return ReportPartUtils.renderLazyLoadingBar();
    }

    return (
      <Chart
        type={type}
        reportPart={reportPart}
        vizEngine={reportPartContent.vizEngine}
        isPreview={props.isPreview}
        chartType={chartProperties.chartType}
        chartOptions={chartProperties}
        seriesOptions={props.reportPart.fieldCollection}
        chartData={chartData}
        printingMode={printingMode}
        doesBreakPage={!props.forDashboard && doesBreakPage && !props.embededReportPart}
        gaugePartType
        viewMode={viewMode}
        style={printingMode && props.style ? props.style : {}}
        finishedRender={props.finishedRender}
        fulfilledData={props.fulfilledData}
        isLoading={reportPart.isLoadingData}
        separator={props.separator}
        elementsCountInContainer={props.elementsCountInContainer}
        pageNumber={props.pageNumber}
        forExporting={props.forExporting}
      >
        {!printingMode && (
          <ChartToolbar
            reportPart={reportPart}
            onDrillDown={props.onDrilldown}
            isShowMetric={reportPartContent.isShowMetric}
          />
        )}
      </Chart>
    );
  }
}

@connect(actions)
export default class GaugeFrontSide extends Component {
  render() {
    const {
      props,
      props: { hideTitle, printingMode }
    } = this;
    const reportPartDetails = props.reportPart || {};
    const isBeingBuild = expr(() => get('isBeingBuild', reportPartDetails.reportPartContent));
    const sizeStyle = props.style ? props.style : {};
    const renderFn = printingMode || isBeingBuild ? this.renderGauge : this.renderDefaultGauge;
    const classes = classnames('report-part-gauge-front-side', {
      'izenda-ReportPart-smallSize': props.width < ReportBodyConstants.REPORT_PART_SMALL_SIZE
    });

    return printingMode ? (
      <div className="report-part-chart-front-side" style={PrintingUtils.getReportPartContainerStyle(props)}>
        <div className={PrintingUtils.getReportPartClassName(props)} style={sizeStyle}>
          {!hideTitle && <ReportPartTitle mode={REPORT_PART_MODE.PREVIEW} reportPart={reportPartDetails} />}
          {renderFn()}
        </div>
      </div>
    ) : (
      <VerticalLayout {...props} className={classes}>
        <ReportPartTitle mode={REPORT_PART_MODE.PREVIEW} reportPart={reportPartDetails} />
        {renderFn()}
      </VerticalLayout>
    );
  }

  renderGauge = () => {
    const { props } = this;
    const sizeStyle = props.style ? props.style : {};
    const omitProps = omit(['width', 'height'], props);

    return <GaugePreview {...omitProps} style={sizeStyle} />;
  };

  renderDefaultGauge = () => {
    const { localization } = this.props;

    return (
      <div className="default-layout">
        <div className="chart-goes-here">
          <span>{localization.getText('REPORTDESIGNER_PLACEHOLDER_GAUGE_GOES_HERE')}</span>
        </div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.GaugeFrontSide.js